(() => {
  if (window.vachtgenootConceptLoaded) return;
  window.vachtgenootConceptLoaded = true;
  const el = (tag, text, className) => { const node = document.createElement(tag); if(text !== undefined) node.textContent = text; if(className) node.className = className; return node; };
  function open(dialog) { if(!dialog) return; document.querySelectorAll('.vg-dialog[open]').forEach(x=>x.close()); dialog.showModal(); }
  document.addEventListener('click', event => {
    const trigger=event.target.closest('button,a'); if(!trigger) return;
    if (trigger.matches('[data-vg-detail-open]')) {
      const dialog = document.getElementById(trigger.dataset.vgDetailOpen);
      const select = dialog?.querySelector('[data-vg-variant-select]');
      const variant = trigger.dataset.vgDetailVariant;
      if (select && variant && [...select.options].some(option => option.value === variant)) {
        select.value = variant;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      open(dialog);
    }
    if(trigger.matches('[data-vg-close]')) trigger.closest('dialog').close();
    if(trigger.closest('.vg-mobile-menu') && trigger.tagName==='A') trigger.closest('.vg-mobile-menu').open=false;
    if (trigger.matches('[data-vg-categories-link]') && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const target = document.getElementById('vg-category-title');
      if (!target) return;
      event.preventDefault();
      const headerHeight = document.querySelector('.vg-header-shell')?.getBoundingClientRect().height || 88;
      const page = window.matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
      const container = page || document.scrollingElement || document.documentElement;
      const top = target.getBoundingClientRect().top - (page?.getBoundingClientRect().top || 0) + container.scrollTop - headerHeight - 24;
      target.focus({ preventScroll: true });
      history.pushState(null, '', '#categorieen');
      container.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || document.querySelector('dialog[open]')) return;
    const panels = [...document.querySelectorAll('.vg-mobile-menu[open], .vg-search-toggle[open]')];
    if (!panels.length) return;
    const activePanel = panels.find(panel => panel.contains(document.activeElement)) || panels[panels.length - 1];
    for (const panel of panels) panel.open = false;
    activePanel.querySelector('summary')?.focus({preventScroll:true});
  });
  function quizOutcome(answers) {
    if (answers[0] === 'pain') return 'pain';
    if (answers[0] === 'tangle') return 'tangle';
    if (answers[2] === 'pup') return 'pup';
    if (answers[2] !== 'adult') return 'unsure';
    if (answers[1] === 'wash') return 'wash';
    if (answers[1] === 'learn') return 'learn';
    return 'brush';
  }
  function initQuiz(root) {
    if(root.dataset.ready) return;
    let copy;
    try { copy = JSON.parse(root.querySelector('[data-vg-quiz-copy]').textContent); } catch (_) { return; }
    const questions = copy.questions;
    if (!Array.isArray(questions) || questions.length !== 3 || !copy.results || !copy.labels) return;
    root.dataset.ready='true';let answers=[];let step=0;
    const question=root.querySelector('[data-vg-question]'),progress=root.querySelector('[data-vg-progress]'),bar=root.querySelector('progress'),prev=root.querySelector('[data-vg-prev]');
    function render() {
      const complete=answers[0]==='pain'||step>=questions.length;
      question.replaceChildren();prev.hidden=step===0;bar.value=complete?questions.length:step+1;
      bar.setAttribute('aria-valuetext',complete?root.dataset.vgCompleteLabel:root.dataset.vgProgressLabel.replace('%number%',step+1));
      if(!complete) {progress.textContent=root.dataset.vgProgressLabel.replace('%number%',step+1);const title=el('h3',questions[step].q);title.tabIndex=-1;const options=el('div',undefined,'vg-quiz-options');questions[step].options.forEach(([value,label])=>{const button=el('button',label);button.type='button';button.dataset.vgAnswer=value;options.append(button);});question.append(title,options);}
      else {
        progress.textContent = copy.labels.result;
        const route = quizOutcome(answers);
        const recommendation = copy.results[route];
        const result = el('div', undefined, 'vg-quiz-result');
        result.dataset.vgResult = route;
        const heading = el('h3', recommendation.title);
        heading.tabIndex = -1;
        const explanation = el('dl', undefined, 'vg-quiz-explainer');
        for (const field of ['why', 'next', 'limits', 'help']) {
          const row = el('div');
          row.append(el('dt', copy.labels[field]), el('dd', recommendation[field]));
          explanation.append(row);
        }
        const responseDetails = el('details', undefined, 'vg-quiz-answers');
        responseDetails.append(el('summary', copy.labels.answers));
        const list = el('ul');
        answers.forEach((answer, index) => {
          const option = questions[index].options.find(item => item[0] === answer);
          if (option) list.append(el('li', option[1]));
        });
        responseDetails.append(list);
        const link = el('a', recommendation.action, 'vg-button');
        link.href = recommendation.target;
        result.append(heading, explanation, responseDetails, link);
        question.append(result);
      }
      question.querySelector('h3')?.focus();
    }
    root.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.matches('[data-vg-answer]')){answers=answers.slice(0,step);answers[step]=button.dataset.vgAnswer;step++;render();}if(button.matches('[data-vg-prev]')){step=Math.max(0,step-1);answers=answers.slice(0,step);render();}if(button.matches('[data-vg-reset]')){answers=[];step=0;render();}});
  }
  function init(){document.querySelectorAll('[data-vg-quiz]').forEach(initQuiz);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();




